<template>
  <a-card :bordered="false">
    <div class="title">红包余额： ￥{{ balanceAmountTotal }} 如需充值请联系管理员</div>
    <div style="margin-bottom: 20px;">
      <span style="color: #409eff; font-size: 13px; margin-right: 15px;">分销有礼</span>
      <a-button class="button-margin" type="primary" @click="openShare">分享活动页</a-button>
      <a-button class="button-margin" type="success" @click="settingRedPack">设置规则</a-button>
    </div>
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      base-key="serviceUrl"
      query-path="redEnvelopes/selectSendList"
    >
      <span slot="sendRedamount" slot-scope="rowItem"> ￥{{ rowItem.record.sendRedamount }} </span>
      <template slot="sendState" slot-scope="rowItem">
        <span v-if="rowItem.record.sendState == 1">成功</span>
        <span v-else>失败</span>
      </template>
    </custom-page-table>
    <a-modal title="分享活动页" :footer="null" :visible="visible" @cancel="handleCancel" :width="880">
      <a-form>
        <a-form-item label="分享链接" v-bind="formItemLayout">
          <a-textarea disabled v-model="config.common.bdUrl" :autoSize="{ minRows: 4, maxRows: 8 }"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayoutBtn">
          <a-button v-clipboard:copy="config.common.bdUrl" v-clipboard:success="onCopy" v-clipboard:error="onError"
          >复制链接
          </a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import formMixin from '../../../../utils/mixins/formMixins'
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'RedEnvelopes',
  mixins: [formMixin],
  data() {
    return {
      columns: [
        {
          title: '微信单号',
          dataIndex: 'sendWxOrderNo'
        },
        {
          title: '用户昵称',
          dataIndex: 'sendUserNickname'
        },
        {
          title: '手机号',
          dataIndex: 'sendPhoneNo'
        },
        {
          title: '金额',
          dataIndex: 'sendRedamount',
          scopedSlots: { customRender: 'sendRedamount' }
        },
        {
          title: '红包祝福语',
          dataIndex: 'sendRedblessings'
        },
        {
          title: '状态',
          dataIndex: 'sendState',
          scopedSlots: { customRender: 'sendState' }
        },
        {
          title: '发送时间',
          dataIndex: 'sendSendTime'
        }
      ],
      queryParams: {},
      balanceAmountTotal: 0,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      visible: false,
      config: {
        common: {
          bdText: '',
          bdDesc: '',
          bdUrl: '',
          bdPic: '',
          bdSign: 'off'
        },
        share: [
          {
            bdSize: 24
          }
        ],
        image: [
          {
            viewType: 'list',
            viewPos: 'top',
            viewColor: 'black',
            viewSize: '16',
            viewList: ['qzone', 'tsina', 'huaban', 'tqq', 'renren']
          }
        ]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'RedEnvelopes', title: '红包' }
    ])
  },
  methods: {
    //获取红包余额接口
    getRedPackNum() {
      this.getHttpServices()
        .getServerApiService()
        .post('redEnvelopes/selectBalance', {
          redMerchantId: this.merchantId,
          redPlatformId: this.platformId
        })
        .then(res => {
          this.balanceAmountTotal = res.balanceAmountTotal
        })
        .catch(err => this.$message.error(err))
    },
    handleCancel() {
      this.visible = false
    },
    // 复制成功
    onCopy(e) {
      this.$message.success('复制成功')
    },
    // 复制失败
    onError(e) {
      this.$message.warning('复制失败')
    },
    openShare() {
      this.visible = true
      this.getRedPacketUrl()
    },
    //获取前端链接
    getRedPacketUrl() {
      let domainUrl = this.getAppConfig().platformConfig.h5Url
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      let params = {
        p: `${character}_${merchantId}_${merchantId}`
      }
      let bdUrl = RouterSwitchHelper.getRedPacketPathUrl(domainUrl, params)
      this.config.common = Object.assign({}, this.config.common, {
        bdText: '分销有礼',
        bdDesc: '分销有礼',
        bdUrl: bdUrl
      })
    },
    // 新增红包
    settingRedPack() {
      this.$router.push({
        name: 'RedpacketSet',
        query: {
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.title {
  margin-bottom: 20px;
  line-height: 22px;
}

.button-margin {
  margin-right: 20px;
}
</style>
